<template>
  <component v-bind:is="currentComponent"></component>
</template>
<script>
import listarProfissionais from "../components/profissionais/Profissionais.vue";
import cadastrarProfissional from "../components/profissionais/CadastrarProfissional.vue";
import editarProfissional from "../components/profissionais/EditarProfissional.vue";

export default {
  components: {
    listarProfissionais,
    cadastrarProfissional,
    editarProfissional,
  },
  data() {
    return {
      currentComponent: "",
    };
  },
  mounted() {
    this.currentComponent =
      this.$route.query.type === "a"
        ? cadastrarProfissional
        : this.$route.query.type === "b"
        ? editarProfissional
        : listarProfissionais;
  },
  watch: {
    $route(to, from) {
      this.currentComponent =
        to.query.type === "a"
          ? "cadastrarProfissional"
          : to.query.type === "b"
          ? "editarProfissional"
          : "listarProfissionais";
    },
  },
};
</script>
<style scoped></style>
